export default __webpack_public_path__ + "static/media/sj-2-lqMAX.ee9a5249.avif";